import styled, { css } from 'styled-components';

interface ContainerProps {
  textColor?: string;
  backgroundColor?: string;
  maxWidth?: number;
  border?: string;
  padding?: string;
  marginLeft?: string;
  isDisabled?: boolean;
  radius?: number;
}

export const Container = styled.button<ContainerProps>`
  background-color: ${({ backgroundColor }) => backgroundColor || '#4a90e2'};
  color: ${({ textColor }) => textColor || '#ffffff'};
  border: ${({ border }) => border || '2px solid transparent'};
  padding: ${({ padding }) => padding || '7px 34px'};
  margin-left: ${({ marginLeft }) => marginLeft || '0px'};

  ${({ isDisabled }) =>
    isDisabled
      ? css`
          background-color: #d7d7d7;
          color: #fff;
        `
      : null}

  border-radius: ${({ radius }) => radius || 50}px;

  box-sizing: border-box;
  font-weight: 700;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  min-height: 36px;
  max-width: ${({ maxWidth }) => maxWidth || 120} px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
